import {
  Body,
  Box,
  Logo,
  MaterialUICore,
  TextField,
  tokens,
} from '@iclinic/design-system';
import { Theme } from '@iclinic/design-system/dist/core';

const {
  styled,
  FormControlLabel,
  Checkbox: PrimitiveCheckbox,
} = MaterialUICore;

export const SignupFormContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: 480,
  maxWidth: '100%',
  background: tokens.color.neutral[0],
  flexShrink: 0,
  margin: '0 auto',
  padding: `${tokens.spacing.md} ${tokens.spacing.sm}`,
  [theme.breakpoints.up('md')]: {
    margin: '0',
    padding: `${tokens.spacing.md} ${tokens.spacing.xl}`,
  },
}));

export const SignupFormLogo = styled(Logo)(() => ({
  margin: '0 auto',
}));

export const SignupField = styled(TextField)(() => ({
  marginBottom: 0,
}));

export const PasswordFeedbackContainer = styled(Box)(() => ({
  display: 'flex',
  gap: tokens.spacing.sm,
  alignItems: 'center',
}));

type FeedbackBodyProps = {
  error?: string;
};

export const FormFeedbackBody = styled(Body)(
  ({ error }: FeedbackBodyProps) => ({
    fontSize: tokens.font.size.xxxs,
    color: error ? tokens.color.feedback.error.main : tokens.color.neutral[300],
    letterSpacing: '0.44px',
  }),
);

type TermsBodyProps = {
  theme: Theme;
  error?: string;
};

export const FormTermsBody = styled(Body)(
  ({ theme, error }: TermsBodyProps) => ({
    fontSize: tokens.font.size.xxs,
    letterSpacing: '0.44px',
    color: error ? theme.palette.error.main : tokens.color.neutral[300],
  }),
);

export const TermsControlLabel = styled(FormControlLabel)(() => ({
  marginRight: 0,
  marginTop: tokens.spacing.sm,
}));

export const RecaptchaBody = styled(Body)(() => ({
  fontSize: tokens.font.size.xxxs,
  color: tokens.color.neutral[300],
  fontWeight: tokens.font.weight.medium,
  letterSpacing: '0.44px',
}));

type CheckboxProps = {
  theme: Theme;
  error?: string;
};

export const Checkbox = styled(PrimitiveCheckbox)(
  ({ theme, error }: CheckboxProps) => ({
    borderColor: error ? theme.palette.error.main : '',
    color: error ? theme.palette.error.main : tokens.color.neutral[300],
  }),
);
